<template lang="pug">
  erp-view(id="OlvideContrasena" ref="OlvideContrasena" title="Olvidé mi contraseña" blank hide-header-title hide-header-action background-color="lightslategrey !important")
    template(slot="content")
      br
      br
      dx-validation-group.login(ref="grupoValidacion")
        .ed-grid.s-grid-1.m-grid-8.rows-gap.gap-1
          .login-body.m-x-4.m-cols-2.s-x-1
            .login-header.dx-widget
              h1.title Olvidé mi contraseña
            .dx-field
              dx-text-box(:value.sync="usuario" placeholder="Ingrese su usuario" styling-mode="filled" )
                dx-validator
                  dx-required-rule(message="Usuario es requerido")
            .dx-field
              dx-button.button(:use-submit-behavior="true" text="Solicitar clave temporal" @click="solicitarClaveTemporal" type="default")
            .dx-field.text-align-center
              dx-button#button(:use-submit-behavior="true" text="Regresar" type="default" styling-mode="text" @click="irLogin")
</template>
<script>
import Gestion from "@/api/Gestion.js";

export default {
  data: () => ({
    usuario: "",
    cargando: false
  }),
  methods: {
    irLogin() {
      this.$router.replace({ name: "Login" });
    },
    solicitarClaveTemporal(e) {
      debugger; //eslint-disable-line     

      if (!e.validationGroup.validate().isValid) {
        return;
      }
      debugger; //eslint-disable-line     

      this.cargando = true;
      Gestion.olvideContrasena(this.usuario)
        .then(res => {
          debugger; //eslint-disable-line     

          if (res) {
            this.$msg.info(
              `Se envió la nueva contraseña a la cuenta asociada al correo electrónico [ `+res.data+' ]'
            );
          }
        })
        .catch(err => {
          if (!err.response) {
            this.$msg.info(`No se pueeede establecer conexión con el servidor: ${err.config.url}`);
          } else {
           // this.$msg.handleError(err.response+' eee');
            this.$msg.handleError(err);
          }
        })
        .finally(() => (this.cargando = false));
    }
  }
};
</script>
<style scoped>
* {
  font-size: 12px !important;
}

.logo {
  width: 172px;
  max-height: 122px;
  border: 1px solid rgba(191, 191, 191, 0.25);
  float: left;
  margin: 0 30px 10px 0;
}
.button {
  display: block;
  font-weight: 500;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.login-header .title {
  color: #2068af;
  font-weight: 500;
  margin: 0;
}

.text-align-center {
  text-align: center;
}

.login-body {
  border: 1px dotted lightgrey;
  background-color: white;
  border-radius: 5px;
  padding: 2em;
}
</style>
<style>
.erp-view-content {
  width: 100vw;
  height: 100vh;
  background-color: lightslategrey !important;
}
</style>
